import useArtistsApi from '🔗/api/artists';
import useFavoriteApi from '🔗/api/favorite';
import useDictApi from '🔗/api/dict';
import useLicensesApi from '🔗/api/licenses';
import usePlaylistsApi from '🔗/api/playlists';
import useTracksApi from '🔗/api/tracks';
import useReleasesApi from '🔗/api/releases';
import useShowcaseApi from '🔗/api/showcase';
import useUserApi from '🔗/api/user';
import useUsersApi from '🔗/api/users';
import useRolesApi from '🔗/api/roles';
import useEntityApi from '🔗/api/entity';
import useTgsApi from '🔗/api/tgs';

const api = {
    get artists() { return () => useArtistsApi(); },
    get favorite() { return () => useFavoriteApi(); },
    get dict() { return () => useDictApi(); },
    get roles() { return () => useRolesApi(); },
    get licenses() { return () => useLicensesApi(); },
    get playlists() { return () => usePlaylistsApi(); },
    get tracks() { return () => useTracksApi(); },
    get releases() { return () => useReleasesApi(); },
    get showcase() { return () => useShowcaseApi(); },
    get user() { return () => useUserApi(); },
    get entity() { return () => useEntityApi(); },
    get users() { return () => useUsersApi(); },
    get tgs() { return () => useTgsApi(); }
};

export default api;
